/**
 * abstract class for all toast providers
 */
class AlertInterface {
    constructor() {
        if (this.constructor === AlertInterface) {
            throw new Error("Cannot instantiate the AlertInterface class");
        }
    }

    show() {
        throw new Error("Method 'show()' must be implemented.");
    }
}

export default AlertInterface;
